import React from 'react'
import NotificationsTable from './NotificationsTable'
import UserInfoManager from './UserInfoManager'
import UsersTable from './UsersTable'

const ViewerPage = ({ profileData, RAListProps }) => {
  const { id } = profileData
  return (
    <>
      <UserInfoManager {...profileData} />
    </>
  )
}

export default ViewerPage
